import processRequest from 'src/services/processRequest';
import { useState, useCallback } from 'react';

export type ClientNotificationModel = {
  messageType: string;
  messageParams: {
    quotationId: number;
    emailClient: string;
    emailCreatorUser: string;
    clientName: string;
    inspectionRequired: boolean;
    quotationUrlSalt: string;
    isAseUser: boolean;
  };
};
/**
 * With this hook we send the request to send an email to the client with the quotation
 */
export default function useNotification(): {
  fetchStatus: string;
  sendNotification: (requestData: ClientNotificationModel) => void;
} {
  const [fetchStatus, setfetchStatus] = useState('initial');

  const sendNotification = useCallback(
    (requestData: ClientNotificationModel) => {
      async function sendNotificationEmail(): Promise<void> {
        try {
          setfetchStatus('requesting');
          await processRequest<unknown>({
            method: 'POST',
            url: 'Notification',
            data: requestData,
          });
          setfetchStatus('success');
        } catch (error) {
          setfetchStatus('failure');
        }
      }
      sendNotificationEmail();
    },
    [],
  );
  return {
    fetchStatus,
    sendNotification,
  };
}
